import React, {useMemo, useState, useEffect} from 'react';
import moment from 'moment';
import removeAccents from 'remove-accents';
import debounce from 'lodash.debounce';
import useRequest from "../hooks/useRequest";
import '../table.css';
import CodeDetail from "./CodeDetail";
import { SortableTh, useSorter } from '../hooks/useSorter';

const styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    margin: 16,
    width: 'calc(100% - 32px)',
    position: 'relative',
    height: 400,
  },
  scrollContainer: {
    overflow: 'scroll',
    flex: 1,
  },
  heading: {
    display: 'flex',
    margin: -4,
    marginTop: -8,
    marginBottom: 8,
    padding: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  search: {
    minWidth: 120,
    maxWidth: 240,
    flex: 1,
    marginRight: 8,
  },
  reload: {
  },
  loading: {
    textAlign: 'center',
  },
  error: {
    textAlign: 'center',
    color: 'red'
  }
}

const resultMapper = (codeList) => ({
  codeList,
  codeById: ((res) => codeList.forEach((code) => res[code._id] = code) || res)({})
});

const INITIAL_RESULT = {
  codeList: [],
  codeById: {}
};

const CodeList = (props) => {
  const customerId = props.customerId;
  const sortState = useSorter('createdAt', 'desc');
  const url = `watermark?${typeof customerId === 'string' ? `customerId=${customerId}&` : ''}${sortState.urlQuery}`;
  const [requestState, reload] = useRequest({
    url,
    method: 'get',
    resultMapper
  });
  const { loading, loaded, result, error } = requestState;
  const { codeList, codeById } = result || INITIAL_RESULT;
  const [editingCodeId, setEditingCodeId] = useState();

  // search stuff start
  const [search, setSearch] = useState('');
  const [filteredCodeList, setFilteredCodeList] = useState([]);
  useEffect(() => {
    console.log('useffect deps', [codeList, search])
    if (!search) {
      setFilteredCodeList(codeList);
    }
  }, [codeList, search]);
  const searchIndexesById = useMemo(() => {
    const res = {};
    const indexKeys = ['code', 'title', 'url'];
    codeList.forEach((code) => {
      res[code._id] = indexKeys.map(k => removeAccents(code?.[k] || "").toLowerCase());
    });
    return res;
  }, [codeList]);
  const debouncedSearch = useMemo(() => {
    return debounce((query) => {
      if (!query) {
        setFilteredCodeList(codeList);
        return;
      }
      const cleanQuery = removeAccents(query).toLowerCase();
      setFilteredCodeList(
        codeList.filter(code => 
          (searchIndexesById[code._id] || []).some(searchIndex => searchIndex.includes(cleanQuery))
        )
      );
    }, 250);
  }, [codeList, searchIndexesById]);
  useEffect(() => {
    debouncedSearch(search);
    return () => {
      debouncedSearch.cancel();
    };
  }, [search, debouncedSearch]);
  // search stuff finish.

  return (
    <>
      <div style={styles.container}>
        <div style={styles.heading}>
          <input type="search" style={styles.search} placeholder="Search..." onChange={(e) => setSearch(e.target.value)} />
          <button type="button" style={styles.reload} onClick={reload}>Reload</button>
        </div>
        <div style={styles.scrollContainer}>
          {loading ? <p style={styles.loading}>loading...</p> : (
            <p style={styles.error}>{error}{'.'}</p>
          )}
          {loaded ? (
            <table>
              <thead>
                <tr>
                  <th>_id</th>
                  <SortableTh name="customerId" sortState={sortState}>CustomerId</SortableTh>
                  <SortableTh name="code" sortState={sortState}>Code</SortableTh>
                  {/* <th>CodeInt</th> */}
                  <th>Title</th>
                  <th>Url</th>
                  <SortableTh name="createdAt" sortState={sortState}>Created</SortableTh>
                  <SortableTh name="updatedAt" sortState={sortState}>Updated</SortableTh>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
              { filteredCodeList.length === 0 ? (
                <tr>
                  <td colSpan={8}>
                    No Codes Found.
                  </td>
                </tr>
              ) : null}
                {
                  filteredCodeList.map(({ _id, customerId, code, title, url, createdAt, updatedAt }) => (
                    <tr key={code}>
                      <td>{_id}</td>
                      <td>{customerId}</td>
                      <td>{code}</td>
                      {/* <td>{(() => {
                        let x = code.split('.');
                        x = x[x.length - 1];
                        x = parseInt(x, 16);
                        return x;
                      })()}</td> */}
                      <td>{title}</td>
                      <td><a href={url} target="_blank" rel="noreferrer noopener nofollower">{url}</a></td>
                      <td>{moment(createdAt).format('lll')}</td>
                      <td>{moment(updatedAt).format('lll')}</td>
                      <td><button type="button" onClick={() => setEditingCodeId(_id)}>Edit</button></td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            ) : null}
        </div>
      </div>
      { editingCodeId ? (
        <CodeDetail {...codeById[editingCodeId]} reload={reload} />
      ) : null}
    </>
  )
}

export default CodeList;
